// ==========================================
// 1. タブ切り替え
// ==========================================
document.querySelectorAll('.fp-tab-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.fp-tab-btn').forEach(function(b) { b.classList.remove('fp-active'); });
    btn.classList.add('fp-active');
    var target = btn.getAttribute('data-tab');
    document.querySelectorAll('.fp-tab-panel').forEach(function(p) { p.classList.remove('fp-active'); });
    document.getElementById('panel-' + target).classList.add('fp-active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});

// ==========================================
// 2. お手入れ開閉（共通化バージョン）
// ==========================================
document.querySelectorAll('.fp-care-toggle-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    // クリックされたボタンの「すぐ次にある要素（パネル）」を取得
    var panel = this.nextElementSibling;
    // クリックされたボタンの中にある「アイコン」を取得
    var icon = this.querySelector('.fp-care-toggle-icon');
    
    // それぞれにクラスを付け外しする
    if (panel) panel.classList.toggle('fp-open');
    if (icon) icon.classList.toggle('fp-open');
  });
});

// ==========================================
// 3. モーダル開閉（カラーラインナップ用）
// ==========================================
function fpOpenModal(imgSrc) {
  const modal = document.getElementById("fp-image-modal");
  const modalImg = document.getElementById("fp-modal-img");
  
  if(modal && modalImg) {
    // モーダルを表示
    modal.style.display = "block";
    modalImg.src = imgSrc;
    // 後ろのページのスクロールを禁止する
    document.body.style.overflow = "hidden";
  }
}

function fpCloseModal() {
  const modal = document.getElementById("fp-image-modal");
  
  if(modal) {
    modal.style.display = "none";
    // 後ろのページのスクロール制限を解除する
    document.body.style.overflow = "";
  }
}

(function() {
  const wrap = document.querySelector('.fp-tab-nav-wrap');
  if (!wrap) return;

  let isDown = false;
  let startX;
  let scrollLeft;
  let moved = false;

  wrap.addEventListener('mousedown', (e) => {
    isDown = true;
    moved = false;
    wrap.classList.add('fp-dragging');
    startX = e.pageX - wrap.offsetLeft;
    scrollLeft = wrap.scrollLeft;
  });

  wrap.addEventListener('mouseleave', () => {
    isDown = false;
    wrap.classList.remove('fp-dragging');
  });

  wrap.addEventListener('mouseup', () => {
    isDown = false;
    wrap.classList.remove('fp-dragging');
  });

  wrap.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - wrap.offsetLeft;
    const walk = x - startX;
    if (Math.abs(walk) > 5) moved = true; // クリックとドラッグを区別する閾値
    wrap.scrollLeft = scrollLeft - walk;
  });

  // ドラッグ後にタブボタンのクリックが誤発火しないようにする
  wrap.addEventListener('click', (e) => {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
})();